import { Component, HostListener, Input, OnInit } from '@angular/core';

import { Observable, firstValueFrom } from 'rxjs';

import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { AgprComponentStyleEnum } from '../../../Basic/enums/social-analysis-types.enum';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';


@Component({
    selector: 'agpr-text-input-dialog',
    templateUrl: './text-input-dialog.component.html',
    styleUrls: ['./text-input-dialog.component.scss'],
    standalone: false
})
export class TextInputDialogComponent extends AbstractDialogComponent implements OnInit {

    @Input() id: string = 'textInputDialog';
    @Input() width: number = 300;
    @Input() heading: string;

    @Input() description: string;
    @Input() placeholder: string;
    @Input() maxLength: number = 64;
    @Input() useTextarea: boolean = false;
    @Input() okLabel: string = 'Core.button.ok';
    @Input() cancelLabel: string = 'Core.button.cancel';

    @Input() style: AgprComponentStyleEnum = AgprComponentStyleEnum.social;
    @Input() initialValue: string;
    @Input() disabledButtonTooltip: string;
    @Input() type: string = 'text';
    @Input() message: string;

    @Input() formValidator: (text: string) => string[];
    @Input() observableFormValidator: (text: string) => Observable<string[]>;
    @Input() submit: (text: string) => Observable<any>;

    isValid: boolean = false;
    loading: boolean = false;

    value: string = '';
    errors: string[] = [];

    readonly componentStyle = AgprComponentStyleEnum;
    readonly buttonStyle = ButtonTypesEnum;

    constructor(
        public coreDialogService: CoreDialogService
    ) {
        super(coreDialogService, 'TextInput');
    }

    @HostListener('window:keyup.escape', ['$event']) onKeyDown(e: KeyboardEvent) {
        this.cancel();
    }

    ngOnInit() {
        if (this.initialValue) {
            this.value = this.initialValue;
            this.validate();
        }
    }


    async ok() {
        this.value = this.value ? this.value.trim() : '';
        await this.validate();

        if (this.isValid) {
            this.loading = true;
            this.submit(this.value).subscribe({
                next: () => this.closeDialog(),
                error: () => this.loading = false
            });
        }
    }


    cancel() {
        this.closeDialog();
    }


    clearErrors() {
        this.isValid = !!this.value?.trim();
        this.errors = [];
    }


    /** Handles checking for empty value and calling the correct form validator function */
    private async validate() {
        let trimmed;
        if (this.value) {
            trimmed = this.value.trim();
        }

        if (!trimmed) {
            this.isValid = false;
            this.errors = [];

            return this.isValid;
        }

        if (this.formValidator) {
            this.errors = this.formValidator(trimmed);
        } else if (this.observableFormValidator) {
            this.errors = await firstValueFrom(this.observableFormValidator(trimmed));
        } else {
            this.errors = [];
        }

        this.isValid = this.errors.length === 0;
    }
}
